/**
 * @generated SignedSource<<722fd4f2fd0f2746c9ce02536b34a38b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoviePageExternalLinkCard_link$data = {
  readonly links: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly favicon: string;
        readonly name: string;
        readonly url: string;
      };
    } | null> | null;
  } | null;
  readonly " $fragmentType": "MoviePageExternalLinkCard_link";
};
export type MoviePageExternalLinkCard_link$key = {
  readonly " $data"?: MoviePageExternalLinkCard_link$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoviePageExternalLinkCard_link">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "links"
        ]
      }
    ]
  },
  "name": "MoviePageExternalLinkCard_link",
  "selections": [
    {
      "alias": "links",
      "args": null,
      "concreteType": "ExternalLinkConnection",
      "kind": "LinkedField",
      "name": "__Movie_links_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExternalLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExternalLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "favicon",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Movie",
  "abstractKey": null
};

(node as any).hash = "013b0db7f04a8a17bc3f3474b5998517";

export default node;
